module.exports = __webpack_public_path__ + "home-block-6-overlay-wide@2x-1K80N_C.png";